<template>
  <div :class="computedClass">
    <slot></slot>
  </div>
</template>
<script>
export default {
  props: {
    // weUI theme only
    backgroundColor: {
      type: [String, Boolean],
      default: false,
    },
    // weUI theme only, same as backgroundColor
    background: {
      type: [String, Boolean],
      default: false,
    },
    // weUI theme only
    color: {
      type:[String, Boolean],
      default: false,
    },
  },
  computed: {
    computedClass() {
      let res = [];
      if (
        utilities.isNonEmptyString(this.backgroundColor) &&
        config.style.weUI.themes.includes(this.backgroundColor)
      ) {
        res.push("bg-" + this.backgroundColor);
      }

      if (
        utilities.isNonEmptyString(this.background) &&
        config.style.weUI.themes.includes(this.background)
      ) {
        res.push("bg-" + this.background);
      }
      if (
        utilities.isNonEmptyString(this.color) &&
        config.style.weUI.themes.includes(this.color)
      ) {
        res.push("c-" + this.color);
      }

      return res;
    },
  },
};
</script>
